interface SectionWaveProps {
  /** Usa no topo de uma seção em vez do rodapé — espelha a curva verticalmente. */
  flip?: boolean;
  /** Classe de cor Tailwind pro fill (ex. "fill-background"). */
  className?: string;
}

// Divisor de seção em curva, usado nas duas transições de maior contraste
// (saída do hero escuro, entrada do CTA final escuro) no lugar da borda reta.
// Fica DENTRO da própria caixa da seção (não faz "sangria" pra fora dela),
// de propósito — a seção pai normalmente tem overflow-hidden (pros blobs),
// que cortaria qualquer coisa posicionada fora dos limites da própria seção.
// Um único path reutilizado nos dois pontos — `flip` decide se ele fica
// colado no rodapé (curva "saindo" da seção) ou no topo (espelhado).
export const SectionWave: React.FC<SectionWaveProps> = ({ flip = false, className = 'fill-background' }) => (
  <svg
    viewBox="0 0 1440 100"
    preserveAspectRatio="none"
    aria-hidden="true"
    className={`pointer-events-none absolute inset-x-0 h-[50px] w-full sm:h-[70px] ${
      flip ? 'top-0 rotate-180' : 'bottom-0'
    } ${className}`}
  >
    <path d="M0,56 C320,110 1120,0 1440,56 L1440,100 L0,100 Z" />
  </svg>
);
